import Nullstack from 'nullstack';
export default function IconFountain({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-fountain",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 16v-5a2 2 0 1 0 -4 0"
  }), "   ", Nullstack.element("path", {
    d: "M15 16v-5a2 2 0 1 1 4 0"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v-10a3 3 0 0 1 6 0"
  }), "   ", Nullstack.element("path", {
    d: "M6 6a3 3 0 0 1 6 0"
  }), "   ", Nullstack.element("path", {
    d: "M3 16h18v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2z"
  }), " ");
}